import * as walletsApi from '../../api/walletsApi';
import useApiCall from '../useApiCall';

const useFetchStakedFancyBearsByWalletApiCall = (walletAddress?: string) =>
  useApiCall<number[], string>(walletsApi.fetchStakedFancyBears, walletAddress);

export default useFetchStakedFancyBearsByWalletApiCall;
